import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import { hideSplash } from '../../actions/SplashScreenActions';
import { checkAccess, addUid } from '../../actions/WelcomeActions';
import * as vars from '../../constants/constants';
import { console_log, parseQueryString,getParameters } from '../../utils/helper';
import { FormattedMessage } from 'react-intl';
import { addFavoriteChannel, addFavoriteVideo, addLikesChannels, addLikesVideos } from '../../actions/FavoriteActions';
import { getDetails, getInterests } from '../../actions/AccountActions';
import { getVideoOrChannelRelatedData } from '../../actions/PlayActions';
import { show, hide } from '../../actions/ActivityIndicatorActions';
import { showMessage } from '../../actions/FlashMessageActions';
import { addVideoHistory, addChannelHistory } from '../../actions/HistoryActions';
import { setHeaderTitle } from '../../actions/HeaderActions';
import { Videos360 } from '../../constants/videos';
import { config } from '../../constants/domainConfig';
import {sendData} from './../../analytics/sendData'
import { getLogo } from '../../constants/multiDomains';
class SplashScreen extends Component {
    constructor(props) {
        super(props);
        this.callApis = this.callApis.bind(this)

    }
    filterVideos(allVids) {
        const restrictedVids = [27, 65];
        const restrictedVidsMe = [27, 50, 65, 91, 92];

        const vids = allVids.map(cat => {
            if (config.domain == 'me')
                return {
                    ...cat,
                    "videos": cat.videos.filter(vid => restrictedVidsMe.indexOf(vid.id) == -1)
                }
            // else if(config.domain === "demo"){
            //     return allVids.filter(category => {
            //         return ["Adventure", "Documentaries", "Escape Reality", "360 Library", "Amazement", "Mix VR", "3D Fun", "Entertainment", "Amazing 360", "360 World", "Tiktok Tips & Tricks"].indexOf(category.categoryName["en"]) < 0
            //     })
            // }
            else return {
                ...cat,
                "videos": cat.videos.filter(vid => restrictedVids.indexOf(vid.id) == -1)
            }
        })
        return vids;
    }
    componentWillMount() {
        if(localStorage.getItem('authorized')) localStorage.removeItem('authorized');
        if(localStorage.getItem('mobiotv')) localStorage.removeItem('mobiotv'); 
        if (!JSON.parse(sessionStorage.getItem('authorized')) || !JSON.parse(sessionStorage.getItem('authorized')).success) {
            sendData('','','','Landed',{})
            const is_staging = getParameters("is_staging");
            const is_staging_exist = is_staging.exist || sessionStorage.getItem("staging") === "1" || sessionStorage.getItem("staging") === "true"
            const is_staging_value = is_staging.value || sessionStorage.getItem("staging")
            /*if (config.domain == 'tr' || config.domain == 'pt') {
                this.props.hideSplash();
                this.props.history.push("/loginWithUsername");
            }*/
            if (config.domain == 'tr') {
                this.props.hideSplash();
                this.props.history.push("/loginWithUsername");
            }
            else if((config.domain === "za" || config.domain === "be") && is_staging_exist){
                let uid_param = getParameters("uid")
                sessionStorage.setItem("staging", is_staging_value)
                const local_domain = "be.mobio360.com"
                const domain = window.location.hostname.includes('localhost') ? local_domain : window.location.hostname
                axios.get(vars.BASE_API_URL + '/checkAccessStaging?uid=' + uid_param.value + `&domain=${domain}`)
                .then((response) => {
                    let data = {
                        success: response.data.success,
                        uid: uid_param.value,
                        token: response.data.data.token,
                        subscriptionInfo: response.data.data.payload
                    };
                    sessionStorage.setItem("authorized", JSON.stringify(data));
                    let staging = response.data.data.payload.staging
                    if(staging) sessionStorage.setItem("staging", true);
                    this.props.checkAccess(data);
                    if (response.data.success) {
                        sendData('', '', '', 'Accessed', { method: 'uid', status: 'success'});
                        axios.defaults.headers.common['authorization'] = response.data.data.token;
                        this.callApis()
                    } else {
                        sendData('','','','Failed',{method: 'uid', status: 'failure'})
                        this.props.hideSplash();
                        this.props.history.push("/category/vod");
                        
                    }
                })
                .catch((error) => {
                    sendData('','','','Failed',{method: 'uid', status: 'failure'})
                    this.props.hideSplash();
                    this.props.history.push("/category/vod");
                    console_log(error);
                });
            }
            else {
                if (parseQueryString(this.props.location.search)['uid'] || new URL(window.location.href).searchParams.get('uid') ) {
                    let uid_param = parseQueryString(this.props.location.search)['uid'] || new URL(window.location.href).searchParams.get('uid')
                    axios.get(vars.BASE_API_URL + '/checkAccess?uid=' + uid_param + '&domain=' + window.location.hostname)
                        .then((response) => {
                            let data = {
                                success: response.data.success,
                                uid: uid_param,
                                token: response.data.data.token,
                                subscriptionInfo: response.data.data.payload
                            };
                            sessionStorage.setItem("authorized", JSON.stringify(data));
                            let staging = response.data.data.payload.staging
                            if(staging) sessionStorage.setItem("staging", true);
                            this.props.checkAccess(data);
                            if (response.data.success) {
                                sendData('', '', '', 'Accessed', { method: 'uid', status: 'success'});
                                axios.defaults.headers.common['authorization'] = response.data.data.token;
                                this.callApis()
                            } else {
                                sendData('','','','Failed',{method: 'uid', status: 'failure'})
                                this.props.hideSplash();
                                this.props.history.push("/category/vod");
                                
                            }
                        })
                        .catch((error) => {
                            sendData('','','','Failed',{method: 'uid', status: 'failure'})
                            this.props.hideSplash();
                            this.props.history.push("/category/vod");
                            console_log(error);
                        });
                }
                else if( new URL(window.location.href).searchParams.get('rid') ){
                    let rid =  new URL(window.location.href).searchParams.get('rid')
                    let staging = new URL(window.location.href).searchParams.get('is_staging') ? '1' : '0'
                    axios.get(vars.BASE_API_URL + `/checkAccessWithRID?rid=${rid}&staging=${staging}`)
                    .then((response) => {
                        let data = {
                            success: response.data.success,
                            uid: response.data.data.payload.token,
                            token: response.data.data.token,
                            subscriptionInfo: response.data.data.payload
                        };
                        sessionStorage.setItem("authorized", JSON.stringify(data))
                        let staging = response.data.data.payload.staging
                        if(staging) sessionStorage.setItem("staging", true);
                        this.props.checkAccess(data);
                        this.props.addUid({
                            uid: data.uid
                        })
                        if (response.data.success) {
                            sendData('', '', '', 'Accessed', { method: 'rid', status: 'success'});
                            axios.defaults.headers.common['authorization'] = response.data.data.token;
                            this.callApis()
                        } else {
                            sendData('','','','Failed',{method: 'rid', status: 'failure'})
                            this.props.hideSplash();
                            this.props.history.push("/category/vod");
                            
                        }
                    })
                    .catch((e) => {
                        sendData('','','','Failed',{method: 'rid', status: 'failure'})
                        this.props.hideSplash();
                        this.props.history.push("/category/vod");
                    })
                }
                else if (parseQueryString(this.props.location.search)['msisdn'] || new URL(window.location.href).searchParams.get("msisdn")) {
                    const msisdn_query = parseQueryString(this.props.location.search)["msisdn"] || new URL(window.location.href).searchParams.get("msisdn")
                    axios.get(vars.BASE_API_URL + '/checkAccessWithMsisdn?msisdn=' + msisdn_query + '&domain=' + window.location.host)
                        .then((response) => {
                            let data = {
                                success: response.data.success,
                                uid: response.data.data.uid,
                                token: response.data.data.token,
                                subscriptionInfo: response.data.data.payload
                            };
                            sessionStorage.setItem("authorized", JSON.stringify(data))
                            this.props.checkAccess(data);
                            if (response.data.success) {
                                sendData('', '', '', 'Accessed', { method: 'msisdn', status: 'success'});
                                axios.defaults.headers.common['authorization'] = response.data.data.token;
                                this.callApis()
                            } else {
                                sendData('','','','Failed',{method: 'msisdn', status: 'failure'})
                                this.props.hideSplash();
                                this.props.history.push("/category/vod");
                                
                            }
                        })
                        .catch((error) => {
                            console_log(error);
                        });
                }
                else {
                    this.props.hideSplash();
                    /*if(config.domain == 'pt') this.props.history.push('/loginWithUsername');
                    else {*/
                        if (this.props.location.pathname === '/') {
                            this.props.history.push('/category/vod');
                        } else {
                            this.props.history.push(this.props.location.pathname + this.props.location.search);
                        }
                    //}
                }
            }

        } else {
            if (this.props.location.pathname === '/') {
                this.props.history.push('/category/vod/?uid=' + parseQueryString(this.props.location.search)['uid']);
            } else {
                this.props.history.push(this.props.location.pathname + this.props.location.search);
            }
        }   
    }
    callApis() {
        this.props.category.videos = this.filterVideos(Videos360);
     
        if (this.props.account.interests.length <= 0) {

            axios.all([axios.get(vars.BASE_API_URL + '/interests'), axios.get(vars.BASE_API_URL + '/favorites'), axios.get(vars.BASE_API_URL + '/history'), axios.get(vars.BASE_API_URL + '/likes')])
                .then(axios.spread(( interests, favorites, history, likes) => {
                   
                    // for interests
                    if (interests.data.data) {
                        this.props.getInterests(interests.data.data);
                    }

                    // for favorites
                    if (favorites.data.data) {
                        this.props.addFavoriteChannel(favorites.data.data.channels);
                        this.props.addFavoriteVideo(favorites.data.data.videos);
                    }

                    // for history
                    if (history.data.data) {
                        this.props.addChannelHistory(history.data.data.channels);
                        this.props.addVideoHistory(history.data.data.videos);
                    }

                    // for likes
                    if (likes.data.data) {
                        this.props.addLikesChannels(likes.data.data.channels);
                        this.props.addLikesVideos(likes.data.data.videos);
                    }
                    
                    if( interests.data.data && favorites.data.data && history.data.data && likes.data.data){
                        // this.props.hideSplash();
                    }
                }))
                .then(() => {
                    axios.get(vars.BASE_API_URL + '/getUserProfile')
                        .then(userProfile => {
                            if (userProfile.data.data) {
                                this.props.getDetails(userProfile.data.data);

                            }
                        })
                        .catch(err => {
                            console.log('error in fetching user profile ----------', err);
                        })
                    this.props.hideSplash();
                })
                .catch(err => {
                    console_log(err);
                });
        } else {
            this.props.getDetails(this.props.account.user);
            this.props.getInterests(this.props.account.interests);
            this.props.addFavoriteChannel(this.props.favorite.channels);
            this.props.addFavoriteVideo(this.props.favorite.videos);
            this.props.addLikesChannels(this.props.favorite.channelsLiked);
            this.props.addLikesVideos(this.props.favorite.videosLiked);
            this.props.addChannelHistory(this.props.historyVideos.channels);
            this.props.addVideoHistory(this.props.historyVideos.videos);

        }
        if (this.props.location.pathname === '/') {
            let uid = parseQueryString(this.props.location.search)['uid'] || new URL(window.location.href).searchParams.get('uid') || JSON.parse(sessionStorage.getItem('authorized')).subscriptionInfo.token
            this.props.history.push('/category/vod/?uid=' + uid);
        } else {
            this.props.history.push(this.props.location.pathname + this.props.location.search);
        }

    }
    componentDidMount() {

        this.props.addUid({
            uid: parseQueryString(this.props.location.search)['uid'] || new URL(window.location.href).searchParams.get('uid')
        });
    }


    render() {
        let className = "splash-screen";
        if (this.props.splash.hideSplash) {
            className += " hidden";
		}
		return (
			<div className={className}>
				<div className="splash-screen__image-wrap">
					<img className="splash-screen__image img-fluid" src={getLogo()} alt="Mobio360" />
				</div>
                <p className="splash-screen__text">
                    <FormattedMessage id="exitReality"
                        defaultMessage="Exit Reality"
                    />
                </p>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        account: state.AccountReducer,
        category: state.CategoryReducer,
        country: state.CountryReducer,
        domain: state.DomainReducer,
        favorite: state.FavoriteReducer,
        flashmessage: state.FlashMessageReducer,
        historyVideos: state.HistoryReducer,
        loader: state.ActivityIndicatorReducer,
        play: state.PlayReducer,
        smartTV: state.SmartTVReducer,
        splash: state.SplashScreenReducer,
        user: state.AuthenticationReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        hideSplash,
        checkAccess,
        addUid,
        show,
        hide,
        getVideoOrChannelRelatedData,
        addFavoriteChannel,
        addFavoriteVideo,
        showMessage,
        setHeaderTitle,
        getDetails,
        addLikesChannels,
        addLikesVideos,
        getInterests,
        addVideoHistory,
        addChannelHistory
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SplashScreen);


// WEBPACK FOOTER //
// ./src/components/SplashScreen/SplashScreen.js